import { Color } from '@anov/3d-core'

const CylinderShader = {
  uniforms: {
    topColor: { value: new Color(0xFFFFFF) },
    bottomColor: { value: new Color(0x2C8AFF) },
    uTime: { value: 0 },
  },
  vertexShader: `
  varying vec3 vPosition;
  varying vec3 vNormal;
  #include <common>
  #include <logdepthbuf_pars_vertex>
  void main() {
      vPosition = position;
      vNormal = normalize(normalMatrix * normal);
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        #include <logdepthbuf_vertex>
  }`,
  fragmentShader: `
  uniform vec3 topColor;
  uniform vec3 bottomColor;
  uniform float uTime;
  varying vec3 vPosition;
  varying vec3 vNormal;
  #include <logdepthbuf_pars_fragment>
  void main() {
   #include <logdepthbuf_fragment>
      // 垂直渐变计算
      float gradient = smoothstep(-1.0, 1.0, vPosition.y);
      vec3 color = mix(bottomColor, topColor, gradient);
      
      // 简化版光照计算
      // vec3 lightDir = normalize(vec3(0.5, 1.0, 0.7));
      // float diff = max(dot(normalize(vNormal), lightDir), 0.0);
      // vec3 lighting = vec3(0.3) + diff * vec3(0.7);
      // gl_FragColor = vec4(color*lighting, 1.0);
      gl_FragColor = vec4(color, 1.0);
      
      // 如需动态效果，取消注释以下内容
       float highlight = sin(vPosition.x * 5.0 + uTime) * 0.1;
       gl_FragColor.rgb += highlight;
  }
`,
}

export default CylinderShader